export default __webpack_public_path__ + "static/media/other.1713c0f2.svg";